import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("ka_admin_token")}` },
});

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, authHeaders());
  return data.url;
};
